document.addEventListener("DOMContentLoaded", () => {
  const productFormComponent = document.querySelector("product-form");
  if (!productFormComponent) return;

  const checkbox = document.querySelector("#gift-wrap-checkbox");
  const GIFT_WRAP_VARIANT_ID = 42732583190633;

  const form = productFormComponent.querySelector("form");
  if (!form) return;

  // 1) Hidden input so Dawn adds main product WITH the Note property
  const NOTE_INPUT_NAME = "properties[Note]";
  let noteInput = form.querySelector(`input[name="${NOTE_INPUT_NAME}"]`);

  function syncNoteInput() {
    if (!checkbox) return;

    if (checkbox.checked) {
      if (!noteInput) {
        noteInput = document.createElement("input");
        noteInput.type = "hidden";
        noteInput.name = NOTE_INPUT_NAME;
        form.appendChild(noteInput);
      }
      noteInput.value = "Gift Wrap Added (Glow and Go)";
    } else {
      noteInput?.remove();
      noteInput = null;
    }
  }

  checkbox?.addEventListener("change", syncNoteInput);
  syncNoteInput();

  // 2) After Dawn successfully adds the main product (popup opens), add gift wrap once.
  // We'll hook into the submit event and run AFTER the current call stack
  // (so Dawn's own JS can run first).
  form.addEventListener("submit", () => {
    if (!checkbox?.checked) return;

    // Prevent multiple giftwrap adds for the same submit
    if (form.dataset.giftWrapAdding === "1") return;
    form.dataset.giftWrapAdding = "1";

    setTimeout(() => {
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({
          items: [{ id: GIFT_WRAP_VARIANT_ID, quantity: 1 }],
        }),
      })
        .then((res) => res.json())
        .then(() => {
          // allow future adds
          form.dataset.giftWrapAdding = "0";
        })
        .catch((err) => {
          console.error(err);
          form.dataset.giftWrapAdding = "0";
        });
    }, 400); // small delay so Dawn opens the popup first
  });
});
